// extracted by mini-css-extract-plugin
export default {"Variable":"Variable3di9WcBWAIWT"};